var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMapInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 15.7C16.18 15.7 16.675 15.495 17.085 15.085C17.495 14.675 17.7 14.18 17.7 13.6C17.7 13.02 17.495 12.525 17.085 12.115C16.675 11.705 16.18 11.5 15.6 11.5C15.02 11.5 14.525 11.705 14.115 12.115C13.705 12.525 13.5 13.02 13.5 13.6C13.5 14.18 13.705 14.675 14.115 15.085C14.525 15.495 15.02 15.7 15.6 15.7ZM15.6 25.63C18.26 23.21 20.225 21.015 21.495 19.045C22.765 17.075 23.4 15.34 23.4 13.84C23.4 11.48 22.645 9.55 21.135 8.05C19.625 6.55 17.78 5.8 15.6 5.8C13.42 5.8 11.575 6.55 10.065 8.05C8.555 9.55 7.8 11.48 7.8 13.84C7.8 15.34 8.45 17.075 9.75 19.045C11.05 21.015 13 23.21 15.6 25.63ZM15.6 28C12.38 25.26 9.975 22.715 8.385 20.365C6.795 18.015 6 15.84 6 13.84C6 10.84 6.965 8.45 8.895 6.67C10.825 4.89 13.06 4 15.6 4C18.14 4 20.375 4.89 22.305 6.67C24.235 8.45 25.2 10.84 25.2 13.84C25.2 15.84 24.405 18.015 22.815 20.365C21.225 22.715 18.82 25.26 15.6 28Z",
    fill: "#00000099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapInactive);
export default __webpack_public_path__ + "static/media/ICON-MAP-INACTIVE.b3243f9877d94a77857f10dfdb2dd801.svg";
export { ForwardRef as ReactComponent };